import React from 'react';
import GlobalNav from './GlobalNav';
import $ from 'jquery';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import { withModelInfo } from '../../common/ModelInfoContext';

const GlobalNavOverlay = ({ isMoreMenuVisible }) => {
  return (
    <div
      className={`global-nav-overlay ${
        isMoreMenuVisible ? 'global-nav-overlay--visible' : ''
      }`}
    />
  );
};

class GlobalNavContainer extends React.Component {
  constructor(props) {
    super(props);

    // Creates a reference to the 'More' dropdown menu
    this.moreMenuDropdownRef = React.createRef();
    this.$moreMenuDropdown = null;

    // Creates a reference to the GlobalNav
    this.globalNavRef = React.createRef();
    this.globalNavHeight = 0;
    this.$globalNav = null;

    this.cgiContainer = $('#byo-cgi-container');
    this.htmlbody = $('html, body');

    this.navVisible = true;
    this.ticking = false;
    this.latestKnownScrollY = 0;

    this.state = { isMoreMenuVisible: false };
  }

  componentDidMount() {
    // Save jQuery references to globalNav and moreDropdown so that we can manipcate the elements in onScroll event
    // handler.
    this.$globalNav = $(this.globalNavRef.current);
    this.$moreMenuDropdown = $(this.moreMenuDropdownRef.current);

    this.globalNavHeight = this.$globalNav.outerHeight(true);

    requestAnimationFrame(this.animate);

    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  componentDidUpdate(prevProps) {
    if (this.props.breakpoint !== prevProps.breakpoint) {
      this.mediaQueryChanged(prevProps.breakpoint, this.props.breakpoint);
    }
  }

  closeMoreMenuDropdown = () => {
    this.setState({ isMoreMenuVisible: false });
    document.body.style.overflow = '';
  };

  onToggleMore = () => {
    this.setState(prevState => ({
      isMoreMenuVisible: !prevState.isMoreMenuVisible
    }));

    if (!this.state.isMoreMenuVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      this.$moreMenuDropdown.one('transitionend', function() {
        document.body.style.overflow = '';
      });
    }
  };

  animate = () => {
    const currentScrollY = this.latestKnownScrollY;
    this.ticking = false;

    const ANIM_SPEED = 100;

    if (currentScrollY > this.globalNavHeight && this.navVisible) {
      this.$globalNav.slideUp(ANIM_SPEED);
      this.navVisible = false;
      if (MediaQuery.atLeast('medium')) {
        this.cgiContainer.animate(
          { marginTop: '-=' + this.globalNavHeight + 'px' },
          ANIM_SPEED
        );
      }
    } else if (currentScrollY < this.globalNavHeight && !this.navVisible) {
      this.$globalNav.slideDown(ANIM_SPEED);
      this.navVisible = true;
      if (MediaQuery.atLeast('medium')) {
        this.cgiContainer.animate(
          { marginTop: '+=' + this.globalNavHeight + 'px' },
          ANIM_SPEED
        );
        this.htmlbody.animate({ scrollTop: 0 }, ANIM_SPEED);
      }
    }
  };

  onScroll = () => {
    if (!MediaQuery.atLeast('medium')) {
      this.latestKnownScrollY = window.scrollY;

      if (!this.ticking) {
        requestAnimationFrame(this.animate);
        this.ticking = true;
      }
    }
  };

  mediaQueryChanged = (previousValue, currentValue) => {
    //This handler uses a Foundation listener to prevent a positioning bug that can occur if the user is on small
    // and resizes to medium after having scrolled the page
    const ANIM_SPEED = 100;
    if (currentValue === 'small' || previousValue === 'small') {
      this.htmlbody.animate({ scrollTop: 0 }, ANIM_SPEED);
      this.cgiContainer.css({ marginTop: 0 });
      this.navVisible = true;
    }
    if (currentValue === 'medium' && previousValue === 'small') {
      this.$globalNav.css({ display: 'block' });
    }

    if (this.state.isMoreMenuVisible) {
      this.setState({ isMoreMenuVisible: false });
      $('body').css({ overflow: '' });
    }
  };

  render() {
    const {
      isFleet,
      isCanada,
      isMobile,
      uiPath,
      enableChat,
      enablePostalCode
    } = this.props.modelInfo;
    return (
      <React.Fragment>
        <GlobalNavOverlay isMoreMenuVisible={this.state.isMoreMenuVisible} />
        <GlobalNav
          {...this.props}
          isFleet={isFleet}
          uiPath={uiPath}
          useLivePersonChat={enableChat}
          disablePostalCode={!enablePostalCode}
          disableSwitchModel={isFleet && isCanada && isMobile}
          isMoreMenuVisible={this.state.isMoreMenuVisible}
          forwardedRef={this.globalNavRef}
          moreMenuDropdownRef={this.moreMenuDropdownRef}
          onToggleMore={this.onToggleMore}
          closeMoreMenuDropdown={this.closeMoreMenuDropdown}
        />
      </React.Fragment>
    );
  }
}

export default withModelInfo(GlobalNavContainer);
